import { Button } from '@components/Button';
import { CARD_CREATION_URL, FRONTEND_URL } from '@/constants/env';
import { useCard } from '@/hooks/useCard';
import { Spinner } from '@components/Spinner';
import useClipboard from 'react-use-clipboard';
import { ReactComponent as EditIcon } from '@/assets/pencil.svg';
import {
  CardActions,
  CardContainer,
  CardCTABlock,
  CardCTAText,
  CardCTATitle,
  CardDetails,
  CardDetailsHeader,
  CardTitle,
  ProfilePhoto,
} from './styled';

function Card() {
  const { data, isLoading } = useCard();
  const cardUrl = `${FRONTEND_URL}/${data?.slug}`;
  const [isCopied, setIsCopied] = useClipboard(cardUrl, {
    successDuration: 2000,
  });
  const profilePhotoUrl =
    data?.avatar_image_url ??
    `${FRONTEND_URL}/assets/images/avatar-default.svg`;

  if (isLoading) {
    return <Spinner variant='small' />;
  }

  if (!data) {
    return (
      <CardCTABlock>
        <CardCTATitle>
          Create Your Card To
          <br />
          Collect Contributions
        </CardCTATitle>
        <CardCTAText>
          Claim your link for the easiest way to accept contributions from your
          supporters with just one click.
        </CardCTAText>
        <div>
          <Button onClick={() => (window.location.href = CARD_CREATION_URL)}>
            Get Started
          </Button>
        </div>
      </CardCTABlock>
    );
  }

  return (
    <CardContainer>
      <ProfilePhoto src={profilePhotoUrl} />
      <CardDetails>
        <CardDetailsHeader>
          <CardTitle>{data.title}</CardTitle>
          <a href={cardUrl}>{cardUrl.replace('https://', '')}</a>
        </CardDetailsHeader>
      </CardDetails>
      <CardActions>
        <Button onClick={setIsCopied}>
          {isCopied ? 'Copied!' : 'Copy Link'}
        </Button>
        <Button
          onClick={() => {
            window.open(cardUrl);
          }}
          variant='secondary'
        >
          View Card
        </Button>
      </CardActions>
      <Button
        onClick={() => {
          window.open(CARD_CREATION_URL);
        }}
        variant='icon'
      >
        <EditIcon />
      </Button>
    </CardContainer>
  );
}

export { Card };
